import styled from '@emotion/styled'

import LogoSVG from 'src/assets/images/content-loading-gray-icon.svg'
import { FC } from 'react'

const Logo = styled.img`
  @keyframes fade {
    0% {
      opacity: 1;
    }
    33% {
      opacity: 0.5;
    }
    66% {
      opacity: 0.2;
    }
    100% {
      opacity: 1;
    }
  }

  animation-name: fade;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`
type AlphamapLogoThrobberProps = {
  style?: React.CSSProperties
}
export const AlphamapLogoThrobber: FC<AlphamapLogoThrobberProps> = ({ style }) => {
  return <Logo style={style} alt="AlphaMap" src={LogoSVG} />
}
